 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"settings": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"settings": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-0044fcbf":"636d03be","chunk-06c6a1b8":"f69c690a","chunk-08bfb246":"600f4b97","chunk-0b525fc9":"69b118ca","chunk-23c185f4":"8c3cc0a5","chunk-2d0aeaf6":"eb5c8fc1","chunk-2d0b1d56":"7d9fd4bf","chunk-2d0b2899":"5585c024","chunk-2d0b59c2":"661fd1e4","chunk-2d0ba11e":"2fb80ad7","chunk-2d0bacc9":"ccc5be7d","chunk-2d0c7ad3":"a535e11d","chunk-2d0c7f15":"ddd58f55","chunk-2d0cb783":"4e14b307","chunk-2d0cba67":"271b1384","chunk-2d0d4067":"657d6848","chunk-2d0d724a":"09972f80","chunk-2d0db2b2":"165e1a31","chunk-2d0ddf81":"a2ef2107","chunk-2d0e88a1":"9e0f3f71","chunk-2d0f0c12":"88e9cc4f","chunk-2d0f0f43":"d25c1efd","chunk-2d20fa8b":"742d8e79","chunk-2d20fee3":"235b765a","chunk-2d213ca8":"fe2f8fd1","chunk-2d2169f4":"46fff76a","chunk-2d21d0fd":"4b3bea99","chunk-2d21d821":"7db26a44","chunk-2d21da35":"c7d9cde7","chunk-2d224c28":"fbe77326","chunk-2d22d366":"bd28deb9","chunk-2d230c8e":"3826ed1c","chunk-2d23756e":"f95ae8a8","chunk-2f1c387f":"fe678f53","chunk-2fc308e7":"9e05b423","chunk-45be5533":"ec94e9da","chunk-523599ca":"08270805","chunk-531523ce":"dd92facc","chunk-68a76640":"c6bdbae9","chunk-743f996d":"27cc5c33","chunk-cffcc456":"d85b001d","chunk-deeef6ae":"c290bfda","chunk-def04b98":"6f47b4e2","chunk-def165fa":"b3664b11","chunk-df195bd2":"f34e9cc5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0044fcbf":1,"chunk-0b525fc9":1,"chunk-23c185f4":1,"chunk-2f1c387f":1,"chunk-2fc308e7":1,"chunk-523599ca":1,"chunk-531523ce":1,"chunk-68a76640":1,"chunk-cffcc456":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-0044fcbf":"da63465e","chunk-06c6a1b8":"31d6cfe0","chunk-08bfb246":"31d6cfe0","chunk-0b525fc9":"5efc80c5","chunk-23c185f4":"cae75413","chunk-2d0aeaf6":"31d6cfe0","chunk-2d0b1d56":"31d6cfe0","chunk-2d0b2899":"31d6cfe0","chunk-2d0b59c2":"31d6cfe0","chunk-2d0ba11e":"31d6cfe0","chunk-2d0bacc9":"31d6cfe0","chunk-2d0c7ad3":"31d6cfe0","chunk-2d0c7f15":"31d6cfe0","chunk-2d0cb783":"31d6cfe0","chunk-2d0cba67":"31d6cfe0","chunk-2d0d4067":"31d6cfe0","chunk-2d0d724a":"31d6cfe0","chunk-2d0db2b2":"31d6cfe0","chunk-2d0ddf81":"31d6cfe0","chunk-2d0e88a1":"31d6cfe0","chunk-2d0f0c12":"31d6cfe0","chunk-2d0f0f43":"31d6cfe0","chunk-2d20fa8b":"31d6cfe0","chunk-2d20fee3":"31d6cfe0","chunk-2d213ca8":"31d6cfe0","chunk-2d2169f4":"31d6cfe0","chunk-2d21d0fd":"31d6cfe0","chunk-2d21d821":"31d6cfe0","chunk-2d21da35":"31d6cfe0","chunk-2d224c28":"31d6cfe0","chunk-2d22d366":"31d6cfe0","chunk-2d230c8e":"31d6cfe0","chunk-2d23756e":"31d6cfe0","chunk-2f1c387f":"beb9fab7","chunk-2fc308e7":"562aaa16","chunk-45be5533":"31d6cfe0","chunk-523599ca":"d73f248d","chunk-531523ce":"3c0fe4f5","chunk-68a76640":"1ad88db1","chunk-743f996d":"31d6cfe0","chunk-cffcc456":"3188bf47","chunk-deeef6ae":"31d6cfe0","chunk-def04b98":"31d6cfe0","chunk-def165fa":"31d6cfe0","chunk-df195bd2":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/public/bundles_vue/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
